/* unplugin-vue-components disabled */import { render } from "./dalateqiapp.vue?vue&type=template&id=0ff36ce2&scoped=true"
import script from "./dalateqiapp.vue?vue&type=script&lang=js"
export * from "./dalateqiapp.vue?vue&type=script&lang=js"

import "./dalateqiapp.vue?vue&type=style&index=0&id=0ff36ce2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff36ce2"]])

export default __exports__